export default class HeaderClass {
	constructor(isForceScrolled = false) {
		this.header = document.getElementById('header');
		this.menuWrapper = document.querySelector('.wrapper-menu');
		this.menuCheckbox = document.getElementById('halpha-menu');
		this.isScrolled = false;
		this.isForceScrolled = isForceScrolled;
	}

	initHeader() {
		let self = this;

		if (self.header != null) {
			self.headerScroll($(window).scrollTop());

			if (self.isForceScrolled) {
				self.header.classList.add('forced');
			}

			$(window).on('scroll', function () {
				self.headerScroll($(window).scrollTop());
			});

			// --- CORRECTION ICI ---
			const burgerLabel = document.querySelector('.wrapper-halpha');

			if (burgerLabel && self.menuCheckbox) {
				burgerLabel.addEventListener('click', function (e) {
					// On empêche le comportement par défaut temporairement pour gérer l'état nous-mêmes
					// e.preventDefault(); // Optionnel, parfois nécessaire si le lien vide recharge la page

					// On utilise un petit délai pour laisser le navigateur mettre à jour l'état 'checked'
					// OU on inverse la logique manuellement.

					// Méthode fiable : Vérifier l'état ACTUEL (avant le clic suivant) pour décider de l'action
					// Mais comme le clic va changer l'état, on va simplement baser l'action sur l'état PRÉSENT.

					setTimeout(() => {
						if (self.menuCheckbox.checked) {
							// Si après le clic, c'est coché -> ON OUVRE
							self.openMenu();
						} else {
							// Si après le clic, c'est décoché -> ON FERME
							self.closeMenu();
						}
					}, 10); // 10ms de délai pour laisser le navigateur traiter le clic natif
				});
			}
			// ----------------------

			// ... Le reste de votre code (Foundation, etc.) ...
			if ($('body').hasClass('xxlarge')) {
				var headerMenu = new Foundation.DropdownMenu($('#menu-menu-principal'));
			} else {
				$('#header-menu').attr('data-submenu-toggle', 'true');
				var headerMenu = new Foundation.AccordionMenu($('#menu-menu-principal'));
			}

			$('#menu-menu-principal .sub-menu .menu-item.current-menu-item').each(function () {
				$(this).parents('.menu-item.is-dropdown-submenu-parent').addClass('current-menu-parent');
			});
		}
	}

	// Plus besoin de switchMenu complexe, on gère tout dans le listener ci-dessus
	// Mais on garde les fonctions open/close pour la clarté

	openMenu() {
		if (this.menuWrapper) {
			this.menuWrapper.classList.add('actif');
		}
		this.header.classList.add('open');

		setTimeout(() => {
			this.header.classList.add('is-open');
		}, 250);
	}

	closeMenu() {
		if (this.menuWrapper) {
			this.menuWrapper.classList.remove('actif');
		}
		this.header.classList.remove('open', 'is-open');
	}

	// ... (Gardez addScrolled, removeScrolled, headerScroll) ...
	addScrolled() {
		this.header.classList.add('scrolled');
		this.isScrolled = true;
	}

	removeScrolled() {
		this.header.classList.remove('scrolled');
		this.isScrolled = false;
	}

	headerScroll(windowScroll) {
		var self = this;
		let headerHeight = self.header.offsetHeight;

		if (Math.abs(windowScroll) >= headerHeight) {
			if (!self.isScrolled) self.addScrolled();
		} else {
			if (self.isScrolled) self.removeScrolled();
			if (self.isScrolled && !self.isForceScrolled) self.removeScrolled();
			if (self.isForceScrolled) self.addScrolled();
		}
	}
}